export default __webpack_public_path__ + "static/media/select.aad0d328.svg";